import Joi from 'joi';

import { SintomasPicotSliderProps } from './models';

const stringRequired = Joi.string().required();

const itemSchema = Joi.object({
  title: stringRequired,
  alt: stringRequired,
  mainImage: stringRequired,
});

const requiredItemSchema = Joi.array().items(itemSchema).min(1).required();

export const SintomasPicotSliderSchema = Joi.object<SintomasPicotSliderProps>({
  title: stringRequired,
  items: requiredItemSchema,
});
